module.exports = __webpack_public_path__ + "static/media/S1N4-4.0f1a6baa.svg";